<template>
    <ResultsNetworkBanner bannerType="success" header="In network">
            <span v-if="benefitCategories?.length > 0 && showSpecialtyUrgentCareCategories">
                Review your plan's
                <span v-for="(benefit, index) in benefitCategories" :key="index">
                    <a :data-card-rank="rank" :href="buildDetailUrl(benefit.category)">
                        {{ benefit.category.toLowerCase() }} benefits 
                    </a>
                    <span v-if="index < benefitCategories.length - 1"> or </span>
                </span>
                to know what's covered.
            </span>
            <span v-else-if="benefitCategories?.length > 0 && viableCategoryFound">
                Review your plan's <a :href="buildDetailUrl(categoryTerm)" :data-card-rank="rank">{{ categoryTerm.toLowerCase() }} benefits</a> to know
                what's covered.
            </span>
            <span v-else>
                Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.
            </span>
    </ResultsNetworkBanner>
</template>
    
<script setup>

const props = defineProps({
    result: Object,
    rank: Number
})

const { benefitCategories, context } = useFCPModel()
const { buildUrl } = useUrls(context.value)
const buildDetailUrl = (categoryTerm) => {
    return buildUrl(`/fcp/csearch/benefits/?category=${categoryTerm}`)
}

// most users only have 1 urgent care category that has detail information, EMERGENCY AND URGENT CARE,
// but the benefit service returns 3 categories, EMERGENCY AND URGENT CARE, EMERGENCY ROOM, and URGENT CARE
// even though EMERGENCY ROOM and URGENT CARE don't return any detail information
// but there are a few users that have special networks that return more than 1 viable emergency care benefit
// so figure out if we're in a special case by checking for an 'EMERGENCY ROOM' category
const showSpecialtyUrgentCareCategories = computed(() => benefitCategories?.value?.find((element) => element.category == 'EMERGENCY ROOM') ? false : true)

// the emergency and urgent care scenario is a little weird on the OLB service side
// normally, we pass the category given by the service call to get the details,
// but the OLB returns nothing for 'emergency room' or 'urgent care' categories
// the only terms it accepts are 'EMERGENCY AND URGENT CARE' or 'EMERGENCY AND URGENTLY NEED CARE SERVICES',
// so first we need to find the category that has that title name and select that one
// then we can pass that term (in this case, the categoryTerm, in caps) to make sure we get details back
// from the service

const viableCategoryFound = benefitCategories?.value?.find((element) => element.category.includes('EMERGENCY AND URGENT'))
const categoryTerm = viableCategoryFound ? viableCategoryFound.category : null

</script>
